module.exports = __webpack_public_path__ + "static/img/cont3003.7fa3d8c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont3003.jpg
// module id = g9Jc
// module chunks = 0